(function () {
    'use strict';

    angular
        .module('riskEventEditModule')
        .controller('RiskEventRelatedRisksController', Controller);

    Controller.$inject = ['$scope', 'grcRiskEventService', 'historyCtxtService', 'permissionService', 'relatedRisks'];


    function Controller($scope, grcRiskEventService, historyCtxtService, permissionService, relatedRisks) {

        $scope.ctrlCtxt.relatedRisks = relatedRisks;

        // Can Edit Related Risk
        $scope.canEditRisksAssociation = permissionService.hasPermission('GRCRiskManagement', 'RiskEventAssociation', 'Edit');
        
        // Add a new related risk
        $scope.addRisk = function (risk) {
            if (!$scope.canEditRisksAssociation) return;

            grcRiskEventService
                .addRiskToRiskEvent($scope.ctrlCtxt.riskEvent.RiskEventID, risk.RiskID)
                .then(function (risks) {
                    $scope.ctrlCtxt.relatedRisks = risks;
                });
        };

        // Unlink a risk
        $scope.unlinkRisk = function (risk) {
            if (!$scope.canEditRisksAssociation) return;

            grcRiskEventService
                .removeRiskFromRiskEvent($scope.ctrlCtxt.riskEvent.RiskEventID, risk.RiskID)
                .then(function () {
                    $scope.ctrlCtxt.relatedRisks = _.reject($scope.ctrlCtxt.relatedRisks, { RiskID: risk.RiskID });
                });
        };

        // Go To Risk
        $scope.goToRisk = function (item) {
            historyCtxtService.goToState('riskEdit',
                { RiskID: item.RiskID },
                'riskEventEdit',
                $scope.ctrlCtxt.riskEvent
            );
        };
    }
})();